export class ConditionCategoryApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConditionCategories() {
    return this.#http.get('/conditionCategory');
  }

  async createConditionCategory(body) {
    return this.#http.post('/conditionCategory', body);
  }

  async updateConditionCategory({ conditionCategoryId, ...body }) {
    return this.#http.put(`/conditionCategory/${conditionCategoryId}`, body);
  }

  async deleteConditionCategory({ conditionCategoryId }) {
    return this.#http.delete(`/conditionCategory/${conditionCategoryId}`);
  }
}
